import React from 'react'
import { Helmet } from 'react-helmet'
import './gdpr.css'

const GDPR = () => {
  return (
    <div className="gdpr-container">
      <Helmet>
        <title>Protecția datelor - Sustin.ro</title>
        <meta property="og:title" content="Protecția datelor - Sustin.ro" />
      </Helmet>

      <img
        alt="background"
        src="/external/map.svg"
        className="gdpr-map"
      />

      <div className="gdpr-content">
        <h1 className="gdpr-title">Protecția datelor</h1>
        
        <section className="gdpr-section">
    <h2>1. Operator și responsabil cu protecția datelor</h2>
    <p>
      Operatorul platformei Sustin.ro este responsabilul de prelucrare, asigurând respectarea cerințelor legale privind protecția datelor. Pentru orice solicitare referitoare la datele personale, contactați-ne la <a href="mailto:hi@romania.org.ro">hi@romania.org.ro</a>.
    </p>
  </section>

  <section className="gdpr-section">
    <h2>2. Date colectate</h2>
    <ul>
      <li>
        <p><strong>Date de identificare</strong>: nume, prenume, CNP – absolut necesare pentru completarea Formularului 230.</p>
      </li>
      <li>
        <p><strong>Date de contact</strong>: adresă, email și număr de telefon (opțional) – pentru a transmite confirmări și notificări.</p>
      </li>
      <li>
        <p><strong>Date de utilizare</strong>: 
          <ul>
            <li><p>Istoricul participărilor la tombole și activitatea în programele de afiliere</p></li>
            <li><p>Link-uri de afiliere generate și utilizate</p></li>
            <li><p>Numărul de formulare completate prin link-uri de afiliere</p></li>
            <li><p>Statutul validării formularelor de către ANAF</p></li>
          </ul>
        </p>
      </li>
    </ul>
  </section>

  <section className="gdpr-section">
    <h2>3. Scopurile prelucrării</h2>
    <ul>
      <li><p><strong>Depunerea Formularului 230</strong>: Asigurăm completarea și transmiterea către ANAF.</p></li>
      <li><p><strong>Gestionarea tombolelor</strong>: 
        <ul>
          <li><p>Înregistrarea participanților la tombola generală</p></li>
          <li><p>Validarea eligibilității pentru premii</p></li>
          <li><p>Distribuția premiilor conform regulilor stabilite</p></li>
        </ul>
      </p></li>
      <li><p><strong>Programul de afiliere</strong>: 
        <ul>
          <li><p>Urmărirea numărului de formulare completate prin link-uri de afiliere</p></li>
          <li><p>Validarea eligibilității pentru recompense</p></li>
          <li><p>Distribuția premiilor garantate și a celor din tombolă</p></li>
        </ul>
      </p></li>
      <li><p><strong>Comunicări operative</strong>: Transmitem notificări privind stadiul procesării și rezultatele tombolelor.</p></li>
      <li><p><strong>Conformitate legală</strong>: Păstrăm date pentru audit și raportare către autorități, conform legislației fiscale.</p></li>
    </ul>
  </section>

  <section className="gdpr-section">
    <h2>4. Temeiul legal</h2>
    <ul>
      <li><p><strong>Consimțământ</strong>: atunci când utilizați platforma Sustin.ro sau solicitați participarea la tombole.</p></li>
      <li><p><strong>Obligații legale</strong>: conform legislației fiscale și de raportare.</p></li>
      <li><p><strong>Interes legitim</strong>: prevenirea fraudelor și asigurarea securității platformei.</p></li>
    </ul>
  </section>

  <section className="gdpr-section">
    <h2>5. Perioada de stocare</h2>
    <p>
      Păstrăm datele pentru perioada necesară atingerii scopurilor pentru care au fost colectate și, ulterior, conform cerințelor fiscale – de regulă 5 ani de la sfârșitul anului fiscal în care au fost colectate.
    </p>
  </section>

  <section className="gdpr-section">
    <h2>6. Drepturile persoanelor vizate</h2>
    <ul>
      <li><p><strong>Acces</strong>: puteți solicita confirmarea faptului că datele sunt prelucrate și o copie a acestora.</p></li>
      <li><p><strong>Rectificare</strong>: puteți corecta orice informație incorectă.</p></li>
      <li><p><strong>Ștergere</strong>: puteți solicita ștergerea datelor („dreptul de a fi uitat”), în condițiile legii.</p></li>
      <li><p><strong>Restricționare</strong>: puteți cere limitarea prelucrării în anumite circumstanțe.</p></li>
      <li><p><strong>Portabilitate</strong>: puteți primi datele într-un format structurat, interoperabil.</p></li>
      <li><p><strong>Opoziție</strong>: puteți contesta prelucrarea pe bază de interes legitim.</p></li>
      <li><p><strong>Retragerea consimțământului</strong>: oricând, fără a afecta legalitatea prelucrării anterioare.</p></li>
    </ul>
    <p>
      Pentru exercitarea drepturilor, vă rugăm să ne contactați la <a href="mailto:hi@romania.org.ro">hi@romania.org.ro</a>.
    </p>
  </section>

  <section className="gdpr-section">
    <h2>7. Securitatea datelor</h2>
    <p>
      Implementăm măsuri tehnice și organizaționale: criptare a bazelor de date, backup-uri periodice și control strict al accesului pentru a preveni accesul neautorizat sau divulgarea accidentală.
    </p>
  </section>

  <section className="gdpr-section">
    <h2>8. Transferuri de date</h2>
    <p>
      Datele nu sunt transferate în afara Spațiului Economic European. În situații excepționale, unde sunt necesare transferuri, vom obține consimțământul explicit și vom implementa garanții adecvate.
      De asemenea, ne rezervăm dreptul de a furniza datele personale ale utilizatorilor câștigători către terțe părți partenere, precum unități de cazare, pentru a facilita acordarea premiilor.
    </p>
  </section>

  <section className="gdpr-section">
    <h2>9. Actualizări</h2>
    <p>
      Această politică este revizuită periodic pentru a reflecta schimbările legislative sau ale activității noastre.
    </p>
  </section>

        <div className="gdpr-footer">
          <p>
            Ultima actualizare: {new Date().toLocaleDateString('ro-RO')}
          </p>
          <p>
          Pentru întrebări sau clarificări privind protecția datelor, vă rugăm să ne contactați la:<br />
      Email: <a href="mailto:hi@romania.org.ro">hi@romania.org.ro</a><br/>
          </p>
        </div>
      </div>
    </div>
  )
}

export default GDPR 